import { Outlet } from 'react-router-dom'
import { Sidebar } from '@/components/navigation/Sidebar'
import { BottomNav } from '@/components/navigation/BottomNav'
import { TopBar } from '@/components/navigation/TopBar'
import { PendingUpgradeBanner } from '@/features/subscription/PendingUpgradeBanner'
import { PaymentDrawerHost } from '@/pages/payments/PaymentDrawerHost'
import { sidebarWidth, useSidebarCollapsed } from '@/components/navigation/sidebar-state'

/** `--shell-sidebar` carries the sidebar width to the fixed bars. */
export function AppShell() {
  const collapsed = useSidebarCollapsed()
  return (
    <div className="min-h-dvh bg-background" style={{ '--shell-sidebar': sidebarWidth(collapsed) } as React.CSSProperties}>
      <Sidebar />
      <div className="flex min-h-dvh flex-col transition-[padding] motion-base md:pl-[var(--shell-sidebar)]">
        <TopBar />
        <PendingUpgradeBanner />
        <main className="flex-1 px-gutter pb-24 pt-4 md:px-6 md:pb-8 md:pt-6 lg:px-8 xl:px-10">
          <Outlet />
        </main>
      </div>
      <BottomNav />
      <PaymentDrawerHost />
    </div>
  )
}
